<template>
  <itemsList
    :title="title"
    :cardComponent="cardComponent"
    :itemList="itemList"
    :propertyKey="propertyKey"
    :itemName="itemName"
    :type="type"
    :noItemsAvailable="noItemsAvailable"
    :initiatorFunction="initiatorFunction"
    :symbol="symbol"
  ></itemsList>
</template>

<script>
import { mapState, mapMutations, mapActions, mapGetters } from "vuex";
import itemsList from "@/views/plus/itemList/sharedComponents/itemsList";

export default {
  name: "News",
  components: { itemsList },
  props: ["symbol"],
  computed: {
    ...mapState("news", ["news"]),
    ...mapGetters(["t"]),
    /*REQUIRED for itemsList pages - data for usage at the html template*/
    title: function() {
      return this.t("News_label");
    },
    cardComponent: function() {
      return "CardNews";
    },
    itemList: function() {
      return this.news;
    },
    propertyKey: function() {
      return "friendly_url";
    },
    itemName: function() {
      return "item";
    },
    type: function() {
      return "news";
    },
    noItemsAvailable: function() {
      return Array.isArray(this.news) && this.news.length == 0;
    },
    initiatorFunction: function(){
      return this.getNews;
    }
    /*end of data for usage at html templates*/
  },
  methods: {
    ...mapActions(["getInfoFromWebsite"]),
    ...mapMutations(["hideComponentMountLoader"]),
    ...mapActions("news", ["getNews"])
  },
  created() {
    this.getInfoFromWebsite("symbols"); //for the related assets images
  },
  mounted() {
    this.hideComponentMountLoader();
  }
};
</script>
